/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const SvgIconBot = props => {
  return (
    <svg viewBox="0 0 31 40" {...props} role="img" aria-hidden="true" focusable="false">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(14.435)">
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.735}
            d="M4.565 3.039c-.633.46-1.8 1.81-3.5 4.052l.59 2.55"
          />
          <ellipse cx={4.675} cy={2.978} fill="#000" rx={2.94} ry={2.978} />
          <ellipse cx={4.675} cy={2.978} fill="#EF6461" rx={1.47} ry={1.489} />
        </g>
        <path
          fill="#EF6461"
          d="M14.519 9.68h1.832c8.019 0 14.519 6.5 14.519 14.518v10.108a4.41 4.41 0 01-4.41 4.41H4.41A4.41 4.41 0 010 34.306V24.198C0 16.179 6.5 9.679 14.519 9.679z"
        />
        <path
          fill="#943E3C"
          d="M15.989 9.68C7.97 9.68 1.47 16.18 1.47 24.197v10.108a4.41 4.41 0 004.41 4.41H4.41A4.41 4.41 0 010 34.305V24.198C0 16.179 6.5 9.679 14.519 9.679z"
        />
        <g transform="translate(9.555 14.89)">
          <ellipse cx={7.35} cy={11.913} fill="#FFF" stroke="#FFF" strokeWidth={0.735} rx={6.982} ry={7.078} />
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.205}
            d="M12.86 1.8A12.529 12.529 0 007.027.372c-2.198 0-4.262.56-6.052 1.543"
          />
          <ellipse cx={7.35} cy={11.913} fill="#000" rx={3.675} ry={3.723} />
          <ellipse cx={9.555} cy={9.679} fill="#FFF" rx={1.47} ry={1.489} />
        </g>
      </g>
    </svg>
  );
};

export default SvgIconBot;
